
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { addAntSmsAccount } from '@/api/product/smsAccount'
import { delObjEmptyKey } from '@/utils'

@Component({
  name: 'basicInformation',
  components: {}
})
export default class extends Vue {
  // @Prop() master!: any

  private infoForm: any = {
    account_name: '',
    account_type: '',
    status: '1',
    extra_param: {
      API_KEY: '',
      API_SECRET: '',
      APP_ID: ''
    },
    active_time: null,
    message: ''
    // invitation_code: ''
    // ancestor: ''
  }
  private loading = false
  private rules: any = {
    account_name: [
      { required: true, message: 'Please enter name', trigger: 'blur' }
    ],
    account_type: [
      { required: true, message: 'Please enter type', trigger: 'change' }
    ]
  }

  private master: any = []
  private loadingList = false

  private back() {
    this.infoForm = {
      account_name: '',
      account_type: '',
      status: '1',
      extra_param: {
        API_KEY: '',
        API_SECRET: '',
        APP_ID: ''
      },
      active_time: null,
      message: ''
    }
    this.$emit('close', false)
  }

  private onestep: boolean = false
  private oneBack() {
    this.onestep = false
  }
  private onSubmit() {
    (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.onestep = true
      } else {
        return false
      }
    })
  }

  private async twoSubmit() {
    try {
      this.loading = true
      delObjEmptyKey(this.infoForm)
      await addAntSmsAccount(this.infoForm).then(() => {
        this.$message({
          message: 'Create successful!',
          type: 'success'
        })
        this.loading = false
        this.back()
      })
    } catch (e) {
      this.back()
      this.loading = false
    }
  }
}
